import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { CabecalhoComponent } from './cabecalho/cabecalho.component';
import { RodapeComponent } from './rodape/rodape.component';
import { NavbarComponent } from './cabecalho/navbar/navbar.component';
import { ApresentacaoComponent } from './apresentacao/apresentacao.component';
import { SobreComponent } from './sobre/sobre.component';
import { CursosComponent } from './cursos/cursos.component';
import { EixoTecnologicoComponent } from './eixo-tecnologico/eixo-tecnologico.component';
import { PrincipalComponent } from './principal/principal.component';

import { CarrouselComponent } from './principal/carrousel/carrousel.component';
import { FaqComponent } from './faq/faq.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { CursoComponent } from './cursos/curso/curso.component';
import { BarraBuscaComponent } from './shared/barra-busca/barra-busca.component';
import { BarraBuscaInstituicoesOlindaComponent } from './shared/barra-busca-instituicoes-olinda/barra-busca-instituicoes-olinda.component';
import { CardComponent } from './shared/card/card.component';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { CursosListaComponent } from './cursos/cursos-lista/cursos-lista.component';
import { PaginaNaoEncontradaComponent } from './pagina-nao-encontrada/pagina-nao-encontrada.component';
import { RemoveAsteristicoPipe } from './shared/pipe/removeAsteristico.pipe';
import { ShortenPipe } from './shared/pipe/shorten.pipe';
import { FormatPipe } from './shared/pipe/format.pipe';
import { NormalisePipe } from './shared/pipe/normalize.pipe';
import { PaginacaoComponent } from './shared/paginacao/paginacao.component';
import { RetornaPrimeiroParagrafo } from './shared/pipe/primeiroParagrafo.pipe';
import { TextToLinkPipe } from './shared/pipe/textToLink.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CursosNaoPermitidosComponent } from './cursos/cursos-nao-permitidos/cursos-nao-permitidos.component';
import { DropdownDirective } from './shared/directives/dropdown.directive';
import { CursosMudaramNomeTabelaConvergenciaComponent } from './cursos/cursos-mudaram-nome-tabela-convergencia/cursos-mudaram-nome-tabela-convergencia.component';
import { DropdownComponent } from './cabecalho/navbar/dropdown/dropdown.component';
import { Format2Pipe } from './shared/pipe/format2.pipe';
import { FilterPipe } from './shared/pipe/filter.pipe';

import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { HigienizaHTMLPipe } from './shared/pipe/higienizaHTML.pipe';
import { RemoveEixoPipe } from './shared/pipe/removeEixo.pipe';

import { CursosExperimentaisComponent } from './cursos/cursos-experimentais/cursos-experimentais.component';
import { SugestoesComponent } from './sugestoes/sugestoes.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { Router, Scroll } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { DisplayDirective } from './shared/directives/display-more.directive';
import { RequiredTextComponent } from './shared/required-text/required-text.component';
import { CustomTextareaComponent } from './shared/custom-textarea/custom-textarea.component';
import { SocialNetwoksComponent } from './shared/redes-sociais/redes-sociais.component';
import { PopUpComponent } from './shared/pop-up/pop-up.component';
import { ListaTermosComponent } from './lista-termos/lista-termos.component';
import { TermsFormaterPipe } from './shared/pipe/termsFormater.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CursosTabelaSubmissaoComponent } from './cursos/cursos-tabela-submissao/cursos-tabela-submissao.component';

import { InstituicoesEnsinoComponent } from './instituicoes-ensino/instituicoes-ensino.component';
import { CardInstituicaoComponent } from './shared/card-instituicao/card-instituicao.component';
import { InstituicaoBuscaComponent } from './shared/instituicao-busca/instituicao-busca.component';
import { PagerService } from './shared/service';
import { FiltroInstituicoesComponent } from './instituicoes-ensino/filtro-instituicoes.component';
import { TitleCaseBrPipe } from './shared/pipe/title-case-br.pipe';
import { ExternalHrefPipe } from './shared/pipe/external-href.pipe';
import { ModalComponent } from './modal/modal/modal.component';
import { LegislacaoComponent } from './legislacao/legislacao.component';
import { AreaTecnologicaComponent } from './area-tecnologica/area-tecnologica.component';
import { HighlightPipe } from './shared/pipe/highlight.pipe';



@NgModule({
  declarations: [
    AppComponent,
    CabecalhoComponent,
    RodapeComponent,
    NavbarComponent,
    ApresentacaoComponent,
    SobreComponent,
    CursosComponent,
    EixoTecnologicoComponent,
    PrincipalComponent,
    CarrouselComponent,
    FaqComponent,
    BreadcrumbComponent,
    CursoComponent,
    BarraBuscaComponent,
    BarraBuscaInstituicoesOlindaComponent,
    CardComponent,
    PesquisaComponent,
    CursosListaComponent,
    PaginaNaoEncontradaComponent,
    RemoveAsteristicoPipe,
    ShortenPipe,
    FormatPipe,
    NormalisePipe,
    PaginacaoComponent,
    RetornaPrimeiroParagrafo,
    TextToLinkPipe,
    CursosNaoPermitidosComponent,
    DropdownDirective,
    CursosMudaramNomeTabelaConvergenciaComponent,
    CursosTabelaSubmissaoComponent,
    DropdownComponent,
    Format2Pipe,
    DisplayDirective,
    HigienizaHTMLPipe,
    RemoveEixoPipe,
    CursosExperimentaisComponent,
    SugestoesComponent,
    SpinnerComponent,
    RequiredTextComponent,
    CustomTextareaComponent,
    SocialNetwoksComponent,
    PopUpComponent,
    ListaTermosComponent,
    TermsFormaterPipe,
    InstituicoesEnsinoComponent,
    CardInstituicaoComponent,
    InstituicaoBuscaComponent,
    FiltroInstituicoesComponent,
    FilterPipe,
    TitleCaseBrPipe,
    ExternalHrefPipe,
    ModalComponent,
    LegislacaoComponent,
    AreaTecnologicaComponent,
    HighlightPipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    BrowserAnimationsModule,
    CarouselModule,
    NgbModule,
    FormsModule
  ],
  providers: [
    PagerService,
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'pt-BR',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private router: Router, private viewportScroller: ViewportScroller) {
    this.viewportScroller.setOffset([0, 60]);
    this.router.events.subscribe((e: Scroll) => {
      if (e.anchor) {
        setTimeout(() => {
          viewportScroller.scrollToAnchor(e.anchor);
        });
      } else if (e.position) {
        viewportScroller.scrollToPosition(e.position);
      } else {
        viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }
}
